<script setup>
const props = defineProps({
  statusCode: {
    type: [String, Number],
    default: null,
  },
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
})

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <header
    class="error-header text-center"
    role="alert"
    aria-live="polite"
  >
    <h1
      v-if="statusCode != null"
      class="error-header__code font-weight-medium mb-2"
    >
      {{ statusCode }}
    </h1>

    <h2
      v-if="title"
      class="text-h4 font-weight-medium mb-2"
    >
      {{ title }}
    </h2>

    <p
      v-if="description"
      class="text-body-1 mb-6 error-header__description"
    >
      {{ description }}
    </p>
  </header>
</template>

<style lang="scss" scoped>
.error-header {
  &__code {
    font-size: clamp(3rem, 5vw, 6rem);
    line-height: clamp(3rem, 5vw, 6rem);
    color: rgb(var(--v-theme-primary));
  }

  &__description {
    max-inline-size: 40ch;
    margin-inline: auto;
  }
}
</style>
